import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gradientsegmentbar',
  standalone : true,
  imports: [CommonModule],
  templateUrl: './gradientsegmentbar.html',
  styleUrl: './gradientsegmentbar.scss',
})
export class Gradientsegmentbar {
  readonly noMargins = input<boolean>(false);
}
